"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserSafeApis = void 0;
const TimeoutSettings_1 = require("./browser/TimeoutSettings");
const codec_1 = require("./codec");
const codec_supports_media_1 = require("./codec-supports-media");
const crf_1 = require("./crf");
const file_extensions_1 = require("./file-extensions");
const get_extension_from_codec_1 = require("./get-extension-from-codec");
const image_format_1 = require("./image-format");
const jpeg_quality_1 = require("./jpeg-quality");
const log_level_1 = require("./log-level");
const options_1 = require("./options");
const audio_codec_1 = require("./options/audio-codec");
const chrome_mode_1 = require("./options/chrome-mode");
const color_space_1 = require("./options/color-space");
const gl_1 = require("./options/gl");
const hardware_acceleration_1 = require("./options/hardware-acceleration");
const options_map_1 = require("./options/options-map");
const video_codec_1 = require("./options/video-codec");
const x264_preset_1 = require("./options/x264-preset");
const pixel_format_1 = require("./pixel-format");
const prores_profile_1 = require("./prores-profile");
const validate_output_filename_1 = require("./validate-output-filename");
exports.BrowserSafeApis = {
    getFileExtensionFromCodec: get_extension_from_codec_1.getFileExtensionFromCodec,
    validCodecs: codec_1.validCodecs,
    validAudioCodecs: audio_codec_1.validAudioCodecs,
    getDefaultCrfForCodec: crf_1.getDefaultCrfForCodec,
    getValidCrfRanges: crf_1.getValidCrfRanges,
    proResProfileOptions: prores_profile_1.proResProfileOptions,
    x264PresetOptions: x264_preset_1.x264PresetOptions,
    hardwareAccelerationOptions: hardware_acceleration_1.hardwareAccelerationOptions,
    validPixelFormats: pixel_format_1.validPixelFormats,
    validOpenGlRenderers: gl_1.validOpenGlRenderers,
    validPixelFormatsForCodec: pixel_format_1.validPixelFormatsForCodec,
    validVideoImageFormats: image_format_1.validVideoImageFormats,
    validStillImageFormats: image_format_1.validStillImageFormats,
    DEFAULT_PIXEL_FORMAT: pixel_format_1.DEFAULT_PIXEL_FORMAT,
    DEFAULT_TIMEOUT: TimeoutSettings_1.DEFAULT_TIMEOUT,
    DEFAULT_JPEG_QUALITY: jpeg_quality_1.DEFAULT_JPEG_QUALITY,
    DEFAULT_COLOR_SPACE: color_space_1.DEFAULT_COLOR_SPACE,
    supportedAudioCodecs: audio_codec_1.supportedAudioCodecs,
    defaultFileExtensionMap: file_extensions_1.defaultFileExtensionMap,
    defaultAudioCodecs: audio_codec_1.defaultAudioCodecs,
    defaultCodecsForFileExtension: get_extension_from_codec_1.defaultCodecsForFileExtension,
    validateOutputFilename: validate_output_filename_1.validateOutputFilename,
    options: options_1.allOptions,
    validColorSpaces: color_space_1.validColorSpaces,
    optionsMap: options_map_1.optionsMap,
    codecSupportsCrf: codec_supports_media_1.codecSupportsCrf,
    codecSupportsVideoBitrate: codec_supports_media_1.codecSupportsVideoBitrate,
    logLevels: log_level_1.logLevels,
    getOutputCodecOrUndefined: video_codec_1.getOutputCodecOrUndefined,
    getExtensionFromAudioCodec: audio_codec_1.getExtensionFromAudioCodec,
    validChromeModeOptions: chrome_mode_1.validChromeModeOptions,
};
